import {Auth0Provider} from '@auth0/auth0-react';
import React from 'react';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';

export const Auth0ProviderWithNavigate = ({children}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    navigate(location.pathname, {state: appState});
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
        scope: 'read:current_user'
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
